module.exports = __webpack_public_path__ + "static/media/Rectangle 28 (1).9752a7b7.png";